import React from 'react'

import { useMeQuery } from './useMeQuery'

export const useIsCoreMember = () => {
  const { data } = useMeQuery()

  return React.useMemo(() => data?.isCoreMember ?? false, [data?.isCoreMember])
}
